import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import { AuthProvider } from '@/context/AuthContext';
import { ThemeProvider } from '@/context/ThemeContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Musteriler from '@/pages/Musteriler';
import MusteriForm from '@/pages/MusteriForm';
import Siparisler from '@/pages/Siparisler';
import SiparisForm from '@/pages/SiparisForm';
import SiparisDetay from '@/pages/SiparisDetay';
import Vincler from '@/pages/Vincler';
import VincForm from '@/pages/VincForm';
import Teklifler from '@/pages/Teklifler';
import TeklifForm from '@/pages/TeklifForm';
import TeklifDetay from '@/pages/TeklifDetay';
import BankaHesaplari from '@/pages/BankaHesaplari';
import AIYukleme from '@/pages/AIYukleme';
import KullaniciYonetimi from '@/pages/KullaniciYonetimi';
import Layout from '@/components/Layout';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ThemeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                {/* Dashboard - Atölye hariç */}
                <Route index element={<ProtectedRoute roles={['admin', 'muhendis', 'muhasebe']}><Dashboard /></ProtectedRoute>} />
                
                {/* Müşteriler - Atölye hariç */}
                <Route path="musteriler" element={<ProtectedRoute roles={['admin', 'muhendis', 'muhasebe']}><Musteriler /></ProtectedRoute>} />
                <Route path="musteriler/yeni" element={<ProtectedRoute roles={['admin', 'muhendis']}><MusteriForm /></ProtectedRoute>} />
                <Route path="musteriler/:id" element={<ProtectedRoute roles={['admin', 'muhendis']}><MusteriForm /></ProtectedRoute>} />
                
                {/* Siparişler - Atölye hariç */}
                <Route path="siparisler" element={<ProtectedRoute roles={['admin', 'muhendis', 'muhasebe']}><Siparisler /></ProtectedRoute>} />
                <Route path="siparisler/yeni" element={<ProtectedRoute roles={['admin', 'muhendis']}><SiparisForm /></ProtectedRoute>} />
                <Route path="siparisler/:id" element={<ProtectedRoute roles={['admin', 'muhendis', 'muhasebe']}><SiparisDetay /></ProtectedRoute>} />
                
                {/* Vinçler - Herkes görebilir, ama ekleme/düzenleme sadece admin ve mühendis */}
                <Route path="vincler" element={<Vincler />} />
                <Route path="vincler/yeni" element={<ProtectedRoute roles={['admin', 'muhendis']}><VincForm /></ProtectedRoute>} />
                <Route path="vincler/:id" element={<ProtectedRoute roles={['admin', 'muhendis']}><VincForm /></ProtectedRoute>} />
                
                {/* Teklifler - Atölye hariç */}
                <Route path="teklifler" element={<ProtectedRoute roles={['admin', 'muhendis', 'muhasebe']}><Teklifler /></ProtectedRoute>} />
                <Route path="teklifler/yeni" element={<ProtectedRoute roles={['admin', 'muhendis']}><TeklifForm /></ProtectedRoute>} />
                <Route path="teklifler/duzenle/:id" element={<ProtectedRoute roles={['admin', 'muhendis']}><TeklifForm /></ProtectedRoute>} />
                <Route path="teklifler/:id" element={<ProtectedRoute roles={['admin', 'muhendis', 'muhasebe']}><TeklifDetay /></ProtectedRoute>} />
                
                {/* Banka Hesapları - Sadece admin ve muhasebe */}
                <Route path="banka-hesaplari" element={<ProtectedRoute roles={['admin', 'muhasebe']}><BankaHesaplari /></ProtectedRoute>} />
                
                {/* AI Yükleme - Atölye hariç */}
                <Route path="ai-yukleme" element={<ProtectedRoute roles={['admin', 'muhendis']}><AIYukleme /></ProtectedRoute>} />
                
                {/* Kullanıcı Yönetimi - Sadece admin */}
                <Route path="kullanici-yonetimi" element={<ProtectedRoute roles={['admin']}><KullaniciYonetimi /></ProtectedRoute>} />
              </Route>
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
